import { AloDbMissionGlobal } from '@/models/alodb/AloDbMissionGlobal'
import { FilterBase } from '@/models/filter/FilterBase'

export interface IMissionGlobalState {    
    status:string
    missionLoaded: boolean
    missionGlobalsId: Array<number>
    missionGlobalById: Record<number,AloDbMissionGlobal>
    //missionGlobals: Array<AloDbMissionGlobal>
    modifideMissionGlobalById: Record<number,AloDbMissionGlobal>
    detailSimulations: Array<number>     
    currentMissionGlobalId:number|null           
    newModifiedAdmMissionGlobal: AloDbMissionGlobal
    missionGlobalLoading: boolean
    adminFilter: FilterBase        
    simuLaunchDic:{[index:number]:boolean}
}
  
const state:IMissionGlobalState = {     
    status: '',
    missionLoaded: false,
    missionGlobalsId: [],
    missionGlobalById: {},
    modifideMissionGlobalById:{},
    detailSimulations:[],  
    currentMissionGlobalId:null,    
    newModifiedAdmMissionGlobal: new AloDbMissionGlobal(),
    missionGlobalLoading:false,
    adminFilter: new FilterBase(),
    simuLaunchDic:{}
}
  
export default state